<template>
  <b-table
    :data="files"
    :loading="isLoading"
    :paginated="true"
    :backend-pagination="true"
    :total="total"
    :per-page="perPage"
    :current-page="currentPage"
    :hoverable="true"
    :striped="true"
    class="is-clickable"
    @page-change="$emit('page-change', $event)"
    @click="$emit('open', $event.id)"
  >
    <b-table-column
      field="registration"
      label="Nr. R.E.S.D.P.S."
      v-slot="props"
    >
      {{ props.row.registration || "—" }}
    </b-table-column>
    <b-table-column field="deceased" label="Defunct" v-slot="props">
      {{ deceased(props.row) }}
    </b-table-column>
    <b-table-column field="dateOfDeath" label="Data decesului" v-slot="props">
      {{ date(props.row.dateOfDeath) }}
    </b-table-column>
    <b-table-column
      field="generalRegistryNumber"
      label="Reg. general"
      v-slot="props"
    >
      {{ props.row.generalRegistryNumber || "—" }}
    </b-table-column>
    <b-table-column field="status" label="Stare" v-slot="props">
      <span :class="['tag', statusTag(props.row.status)]">
        {{ statusLabel(props.row.status) }}
      </span>
    </b-table-column>
    <b-table-column field="transmissionDeadline" label="Termen transmitere">
      <template #header>
        Termen transmitere
        <!-- Tabelul are overflow-x: auto si ar taia tooltip-ul. -->
        <resdps-help-tip
          :text="deadlineHelp"
          position="is-bottom"
          :append-to-body="true"
        />
      </template>
      <template v-slot="props">
        <span :class="deadlineClass(props.row)">{{
          deadlineText(props.row)
        }}</span>
      </template>
    </b-table-column>
    <b-table-column
      field="chamberRegistrationNumber"
      label="Nr. Camera"
      v-slot="props"
    >
      {{ props.row.chamberRegistrationNumber || "—" }}
    </b-table-column>
    <template #empty>
      <div class="content has-text-grey has-text-centered">
        <p>{{ isLoading ? "Incarcare..." : "Nici un dosar" }}</p>
      </div>
    </template>
  </b-table>
</template>

<script>
import {
  deadlineLabel,
  deadlineState,
  formatDate,
  formatDeceased,
  statusLabel,
  statusTag,
} from "@/helpers/resdps";
import { CONCEPT_HELP } from "@/helpers/resdpsHelp";
import ResdpsHelpTip from "@/components/succession/resdps-help-tip.vue";

export default {
  name: "SuccessionFilesTable",
  components: { ResdpsHelpTip },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 20,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    today: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      deadlineHelp: CONCEPT_HELP.transmissionDeadline.text,
    };
  },
  methods: {
    deceased: formatDeceased,
    date: formatDate,
    statusLabel,
    statusTag,
    deadlineClass(row) {
      const { state } = deadlineState(row.transmissionDeadline, this.today);
      return {
        "has-text-danger": state === "late",
        "has-text-warning-dark": state === "soon",
        "has-text-weight-semibold": state === "late" || state === "soon",
      };
    },
    deadlineText(row) {
      const deadline = deadlineState(row.transmissionDeadline, this.today);
      if (deadline.state === "none") return "—";
      return (
        formatDate(row.transmissionDeadline) + " · " + deadlineLabel(deadline)
      );
    },
  },
};
</script>
